import { Button, ButtonRow } from '@ksyos/design-system';
import { useState } from 'react';
import type { IAltoStepProps } from '../../NewAltoDermaOthProcedure';
import type { IRegularStepProps } from '../../NewDermaOthProcedure';
import { LoaderSpinner } from '../../../../elements/atoms/loaderSpinner/LoaderSpinner';
import { CustomContainer } from '../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';
import { AssetDropzoneWithThumbnails } from '../../../../elements/organisms/assetDropzoneWithThumbnails/AssetDropzoneWithThumbnails';
import { PageIntro } from '../../../../elements/organisms/pageIntro/PageIntro';
import { Instructions } from './Shared';

export function Step2(props: IRegularStepProps | IAltoStepProps) {
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const tokenId = 'tokenId' in props ? props.tokenId : undefined;
    const continueButtonText = isUploading ? 'Je foto wordt geladen...' : "Verder naar detailfoto's";

    return (
        <>
            <PageIntro
                subtitle="Op de foto moet te zien zijn waar op het lichaam de aandoening zit."
                title="Overzichtsfoto"
            />
            <CustomContainer>
                <AssetDropzoneWithThumbnails
                    acceptedFiles=".png,.jpeg,.jpg,.heic,.heif"
                    alternativeUrl={tokenId ? `/api/upload/alto/uploadUrl?tokenId=${tokenId}` : undefined}
                    files={props.procedure.customControlData.overviewFiles}
                    handleChange={(overviewFiles) => {
                        props.handleChange({ overviewFiles });
                    }}
                    id={0}
                    limit={1}
                    onUploadStatusChanged={(uploadingStatus: boolean) => {
                        setIsUploading(uploadingStatus);
                        if (props.onUploadStatusChanged) {
                            props.onUploadStatusChanged(uploadingStatus);
                        }
                    }}
                    placeholder="Foto toevoegen"
                />
                <Stack>
                    <Instructions />
                </Stack>
                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        isDisabled={isUploading || props.procedure.customControlData.overviewFiles.length === 0}
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        {continueButtonText}
                        {isUploading && <LoaderSpinner />}
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
